module.exports = __webpack_public_path__ + "img/ins-test.292844fd.svg";